import { Modal } from 'ant-design-vue';

export default {
    install(Vue) {
      Vue.config.globalProperties.$confirm = Modal.confirm;
    }
  };